import { Language } from '../../../enums/const-enums';

export interface RassRaboScannerTranslations {
  errors: {
    timeout: AppModel.TimeoutTranslation;
  };
  instructions: {
    initial: string;
    login: string;
    sign: string;
    no_switch_allowed: {
      leftSide: string;
      middle: string;
      rightSide: string;
    };
    expired: string;
    credit_card: {
      leftSide: string;
      rightSide: string;
    };
    dark_mode: {
      leftSide: string;
      middle: string;
      rightSide: string;
    };
  };
  color_code: string;
}

const nlTranslations: RassRaboScannerTranslations = {
  errors: {
    timeout: {
      text: 'Fout bij het bereiken van de server, probeer opnieuw!',
      type: 'warning',
    },
  },
  instructions: {
    initial: 'Vul eerst je rekeningnummer en pasnummer in.',
    login:
      'Plaats de betaalpas in de Rabo Scanner. Voer de pincode in. <br> Scan de kleurcode en vul hieronder de toegangscode in.',
    sign: 'Plaats de betaalpas in de Rabo Scanner. Voer de pincode in. <br> Scan de kleurcode en vul hieronder de signeercode in.',
    no_switch_allowed: {
      leftSide: 'Plaats de betaalpas van rekening ',
      middle: ' met pasnummer ',
      rightSide:
        ' in de Rabo Scanner. Voer de pincode in. <br> Scan de kleurcode en vul hieronder de signeercode in.',
    },
    expired: `<rds-notification type='warning' aria-live="assertive" header='De kleurcode is verlopen'><a role="button" tabindex="0" onclick="document.querySelector('rass-sign').shadowRoot.getElementById('challenge-image').click()" onkeydown="if (event.key === 'Enter') { event.preventDefault(); event.target.click(); }" class="rds-link rds-text-link--inline cursor-pointer">Vernieuw</a> de kleurcode door er op te klikken.<br><br>Of bekijk het <a role="button" tabindex="0" onclick="document.querySelector('rass-sign').shadowRoot.querySelector('rass-rabo-scanner').showVideo()" onkeydown="if (event.key === 'Enter') { event.preventDefault(); event.target.click(); }" class="rds-link rds-text-link--inline cursor-pointer">voorbeeld</a>.</rds-notification>`,
    credit_card: {
      leftSide: 'Plaats de creditcard ',
      rightSide:
        ' in de Rabo Scanner. Voer de pincode van de creditcard in. Scan de kleurcode en vul hieronder de signeercode in.',
    },
    dark_mode: {
      leftSide: 'Gebruik ',
      middle: 'voldoende licht',
      rightSide: ' om te scannen.',
    },
  },
  color_code: 'Kleurcode',
};

const enTranslations: RassRaboScannerTranslations = {
  errors: {
    timeout: {
      text: 'Error while reaching the server, please try again!',
      type: 'warning',
    },
  },
  instructions: {
    initial: 'Please enter your account number and card number.',
    login:
      'Insert the bank card into the Rabo Scanner. Enter your PIN. <br> Scan the color code and enter the access code below.',
    sign: 'Insert the bank card into the Rabo Scanner. Enter your PIN. <br> Scan the color code and enter the signing code below.',
    no_switch_allowed: {
      leftSide: 'Insert the debit card from account ',
      middle: ' with card number ',
      rightSide:
        ' into the Rabo Scanner. Enter your PIN. <br> Scan the color code and enter the signing code below.',
    },
    expired: `<rds-notification type='warning' aria-live="assertive" header='The color code has expired'><a tabindex="0" role="button" onclick="document.querySelector('rass-sign').shadowRoot.getElementById('challenge-image').click()" onkeydown="if (event.key === 'Enter') { event.preventDefault(); event.target.click(); }" class="rds-link rds-text-link--inline cursor-pointer">Refresh</a> the color code by clicking on it.<br><br>Or watch the <a role="button" tabindex="0" onclick="document.querySelector('rass-sign').shadowRoot.querySelector('rass-rabo-scanner').showVideo()" onkeydown="if (event.key === 'Enter') { event.preventDefault(); event.target.click(); }" class="rds-link rds-text-link--inline cursor-pointer">example</a>.</rds-notification>`,
    credit_card: {
      leftSide: 'Insert credit card ',
      rightSide:
        ' into the Rabo Scanner. Enter the PIN of the credit card. Scan the color code and enter the signing code below.',
    },
    dark_mode: {
      leftSide: 'Use ',
      middle: 'sufficient light',
      rightSide: ' for scanning.',
    },
  },
  color_code: 'Color code',
};

export const rassRaboScannerTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
